import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { IStatement } from '../../../model/statement'
import convoStore from '../convo-store'
import statementStore from '../../statement/statement-store'

export default async function addFormStatement(context: BareActionContext<ConvoState, RootState>, statement: IStatement)
{
  const form = convoStore.state.convoForm

  if (form.statements.indexOf(statement) < 0) {
    form.statements.push(statement)
  }
  statementStore.dispatchHideStatement(statement)

  return
}
